import Vue from 'vue'
import Vuex from 'vuex'

import config from './modules/config'
import subpageConfigure from './modules/subpageConfigure'
import coverConfig from './modules/coverConfig'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    lastTime: null
  },
  mutations: {
    UPDATE_LASTTIME: state => {
      state.lastTime = new Date().getTime()
    }
  },
  modules: {
    config,
    subpageConfigure,
    coverConfig
  }
})

export default store
